import React from 'react';

export default function IcTires(props) {
  return (
    <svg width='1em' height='1em' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.55382 9.96803C8.20193 10.5635 8 11.2582 8 12C8 12.7418 8.20193 13.4365 8.55382 14.032L10.5858 12L8.55382 9.96803ZM9.96803 8.55382L12 10.5858L14.032 8.55382C13.4365 8.20193 12.7418 8 12 8C11.2582 8 10.5635 8.20193 9.96803 8.55382ZM15.4462 9.96803L13.4142 12L15.4462 14.032C15.7981 13.4365 16 12.7418 16 12C16 11.2582 15.7981 10.5635 15.4462 9.96803ZM14.032 15.4462L12 13.4142L9.96803 15.4462C10.5635 15.7981 11.2582 16 12 16C12.7418 16 13.4365 15.7981 14.032 15.4462ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z" 
        fill="currentColor" />
    </svg>
  );
}
